// extracted by extract-css-chunks-webpack-plugin
module.exports = {"seller-page-past-section":"OWFJjhs100g3xWl9maXJ","header-text-large":"RkvzH9AUYTNtb74RTePs","pagination":"jQTcwBEy2NoSbX4Bmc7I","grid":"dmHzQn5l6f7wsoI0X7GQ"};